import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const WhyUs = () => {
  const { t } = useLang();

  return (
    <section
      id="why"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10 bg-gradient-to-b from-[#0a0a0a] to-[#0e0e0e]"
      data-testid="why-section"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ff4500] mb-6">
          {t.sectionLabels.why}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-[10vw] md:text-6xl lg:text-7xl whitespace-pre-line max-w-4xl"
          data-testid="why-title"
        >
          {t.why.title}
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
          {t.why.items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#0d0d0d] p-8 md:p-12 group hover:bg-[#161616] transition"
              data-testid={`why-item-${i + 1}`}
            >
              <div className="flex items-baseline gap-4">
                <span className="font-display text-5xl md:text-6xl text-[#ccff00] group-hover:text-[#ff4500] transition">
                  {item.n}
                </span>
                <h3 className="font-display text-2xl md:text-3xl">{item.title}</h3>
              </div>
              <p className="mt-6 text-white/65 leading-relaxed text-base md:text-lg max-w-xl">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
